const KNB = require('@dp/knb')
const latestVersion = '9.3.0'
var KnbUtil = {
  getNetwork() {
    KNB.ready(function () {
      //确保knb loader已经加载完成具体的knb实现
      //确保桥的native部分已经ready，权限验证已经通过(在点评主App)
      KNB.getNetworkType({
        success: function (ret) {
          return ret.networkType; //'2g','3g','4g','wifi',undefined
        }
      });
    });
  },
  getUA() {
    KNB.ready(function () {
      KNB.getUA({
        success: function (info) {
          let isDPAPP = false
          let isNewVersion = false
          if (info && info.appName == 'dianping') {
            isDPAPP = true
            isNewVersion = KNB.Semver.gte(info.appVersion, latestVersion)
          }
          let uainfo = {
            'isDPAPP': isDPAPP,
            'isNewVersion': isNewVersion
          }
          return uainfo
        }
      })
    })
  },
  getQueryString(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) {
      return unescape(r[2]);
    }
    return null;
  },
  //获取用户信息
  getUserInfo() {
    return new Promise((resolve, reject) => {
      KNB.ready(function () {
        console.log('knb ready')
        try {
          KNB.getUserInfo({
            success: function (user) {
              var type = user.type; //账户类型：‘dp’,'mt'
              var userId = user.userId; //用户ID, -1时表示未登录
              var uuid = user.uuid; //dp用户为dpid, 美团用户为uuid
              var token = user.token; //mt 7.6后才支持
              var isLogin = false
              if (userId > 0) {
                isLogin = true
              }

              resolve({
                type,
                userId,
                uuid,
                token,
                isLogin,
                isApp: true
              })
            }
          });
        } catch (e) {
          reject(e)
        }

      })
    })

  },
  // img http --> https
  fixImgUrl(url) {
    return url && url.indexOf('http://') !== -1 ? url.replace('http://', 'https://') : url;
  },
  formatTime(duration) {
    let sec = 0;
    let min = 0;
    let hour = 0;
    if (duration < 60) {
      return '00:' + (duration < 10 ? '0' + duration : duration);
    } else {
      if (duration < 3600) {
        min = Math.floor(duration / 60 % 60);
        sec = duration - min * 60;
        return '' + (min < 10 ? '0' + min : min) + ':' + (sec < 10 ? '0' + sec : sec);
      } else {
        hour = Math.floor(duration / 3600 % 24);
        min = Math.floor(duration / 60 % 60);
        sec = duration - hour * 3600 - min * 60;
        return '' + (hour < 10 ? '0' + hour : hour) + ':' + (min < 10 ? '0' + min : min) + ':' + (sec < 10 ? '0' + sec : sec);
      }
    }
  },
  replaceFirstUper(str) {
    str = str.toLowerCase();
    return str.replace(/\b(\w)|\s(\w)/g, function (m) {
      return m.toUpperCase();
    })
  }
}
export default KnbUtil



// WEBPACK FOOTER //
// ./src/libs/util.js